import { updateShySuiteHeaderMode, type UpdateShySuiteHeaderModeActionMessage, } from "../actions/publicActions";
import { mutator } from "satcheljs";
import { getStore } from "../store/store";

export const updateShySuiteHeaderModeMutator: (actionMessage: UpdateShySuiteHeaderModeActionMessage) => void = 
// eslint-disable-next-line owa-custom-rules/prefer-mutator-action -- BASELINE, DO NOT COPY!
mutator(updateShySuiteHeaderMode, ({ isShy }) => {
    getStore().isShy = isShy;
});
